import { setBlockTracking as _setBlockTracking, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-fe82484a"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createTextVNode("How it works")
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" Clippy Cloud is just simple, it was built to make everything easy for you. ")
const _hoisted_3 = { class: "SectionHowItWorks__cards-container" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" After 30 minutes, all files expire automatically. Then you can no longer access them. ")
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" No data from you will be saved. As long as you stay in the same browser, you can see all your uploaded files. ")
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" You will never need to pay for this service. It was created with the intention of simplifying your life. ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Heading = _resolveComponent("Heading")!
  const _component_Text = _resolveComponent("Text")!
  const _component_IconTimer = _resolveComponent("IconTimer")!
  const _component_CardInfo = _resolveComponent("CardInfo")!
  const _component_IconFast = _resolveComponent("IconFast")!
  const _component_IconFlower = _resolveComponent("IconFlower")!
  const _component_Container = _resolveComponent("Container")!

  return _cache[0] || (
    _setBlockTracking(-1),
    _cache[0] = _createElementVNode("section", { class: "SectionHowItWorks" }, [
      _createVNode(_component_Container, null, {
        default: _withCtx(() => [
          _createVNode(_component_Heading, { level: "2" }, {
            default: _withCtx(() => [
              _hoisted_1
            ]),
            _: 1
          }),
          _createVNode(_component_Text, { class: "SectionHowItWorks__description" }, {
            default: _withCtx(() => [
              _hoisted_2
            ]),
            _: 1
          }),
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_CardInfo, {
              title: "All Files Expire",
              color: _ctx.makeRgba(_ctx.EThemeColors.kournikovaRGB, _ctx.cardOpacity)
            }, {
              icon: _withCtx(() => [
                _createVNode(_component_IconTimer, {
                  color: _ctx.EThemeColors.kournikova,
                  size: "54"
                }, null, 8, ["color"])
              ]),
              default: _withCtx(() => [
                _hoisted_4
              ]),
              _: 1
            }, 8, ["color"]),
            _createVNode(_component_CardInfo, {
              title: "No Login Required",
              color: _ctx.makeRgba(_ctx.EThemeColors.geraldineRGB, _ctx.cardOpacity)
            }, {
              icon: _withCtx(() => [
                _createVNode(_component_IconFast, {
                  color: _ctx.EThemeColors.geraldine,
                  size: "54"
                }, null, 8, ["color"])
              ]),
              default: _withCtx(() => [
                _hoisted_5
              ]),
              _: 1
            }, 8, ["color"]),
            _createVNode(_component_CardInfo, {
              title: "For Free Forever",
              color: _ctx.makeRgba(_ctx.EThemeColors.heliotropeRGB, _ctx.cardOpacity)
            }, {
              icon: _withCtx(() => [
                _createVNode(_component_IconFlower, {
                  color: _ctx.EThemeColors.heliotrope,
                  size: "54"
                }, null, 8, ["color"])
              ]),
              default: _withCtx(() => [
                _hoisted_6
              ]),
              _: 1
            }, 8, ["color"])
          ])
        ]),
        _: 1
      })
    ]),
    _setBlockTracking(1),
    _cache[0]
  )
}